<template>
<!--    <div class="d-flex flex-row justify-content-start align-content-center">-->
<!--      <mdb-btn-->
<!--        gradient="aqua"-->
<!--        size="sm"-->
<!--        rounded-->
<!--        @click.native="refresh()"-->
<!--      ><mdb-icon icon="sync-alt" /></mdb-btn>-->
<!--    </div>-->
  <div class="d-flex flex-row w-100 h-100 justify-content-between">
    <div class="d-flex flex-column mr-2 selects-wrapper">
      <h5>Node</h5>
      <div class="d-flex flex-column overflow-hidden mb-2 h-100">
        <bridge8-select-list
          class="ml-2 mr-2 h-50"
          entity="label"
          :options="labels"
          label="Label"
          :search="true"
          :value="label"
          @selected="$bus.$emit('admin-goto', {label: $event})"
        />
        <bridge8-select-list
          class="ml-2 mr-2 h-50"
          :options="nodes"
          entity="node"
          label="Entity"
          :text-callback="obj => obj.name || '--- n/a ---'"
          :search="true"
          :value="node"
          @selected="node = $event"
        />
      </div>
      <div class="d-flex flex-column justify-content-center align-items-around">
        <admin-tab-cart/>
        <admin-tab-search />
        <div>
          <mdb-btn-group class="mb-1">
            <mdb-btn
              v-if="isAdmin"
              :disabled="!label"
              rounded
              gradient="aqua"
              size="sm"
              icon="file"
              title="Create new node"
              @click.native="createNode()"
            />
            <mdb-btn
              v-if="isAdmin"
              :disabled="!node"
              rounded
              gradient="aqua"
              size="sm"
              icon="copy"
              title="Clone selected node"
              @click.native="cloneNode()"
            />
            <mdb-btn
              v-if="isAdmin"
              :disabled="!isEditMode || !this.node"
              rounded
              gradient="sunny-morning"
              size="sm"
              icon="trash"
              title="Delete selected node"
              @click.native="deleteNode()"
            />
          </mdb-btn-group>
          <mdb-btn-group class="mb-1">
            <mdb-btn
              rounded
              gradient="aqua"
              size="sm"
              icon="table"
              title="Bulk update from table"
              @click.native="tableUpdate()"
            />
            <mdb-btn
              :disabled="!node"
              rounded
              gradient="aqua"
              size="sm"
              icon="cart-plus"
              title="Add to cart"
              @click.native="addToCart()"
            />
            <mdb-btn
              v-if="isAdmin"
              :title="`${isEditMode ? 'Disable' : 'Enable'} irrevocable operations`"
              rounded
              gradient="aqua"
              size="sm"
              :icon="isEditMode ? 'lock-open' : 'lock'"
              @click.native="isEditMode = !isEditMode"
            />
          </mdb-btn-group>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column flex-grow-1 ml-2">
      <admin-tab-entity-properties
        class="admin-tab-node-properties"
        header="Node Properties"
        :properties="nodeProperties"
        :read-only="!isEditMode || !node"
        @props-change="propertiesChanged($event)"
      />
      <admin-tab-node-relationships
        class="flex-grow-1 mt-2"
        :read-only="!isEditMode || !node"
        :node-uuid="node ? node.uuid : null"
      />
    </div>
  </div>
</template>

<script>
import { mdbBtnGroup, mdbBtn, mdbIcon } from 'mdbvue'
import Bridge8SelectList from './Bridge8SelectList'
import {mapGetters, mapActions} from 'vuex'
import AdminTabEntityProperties from './AdminTabEntityProperties'
import AdminTabNodeRelationships from './AdminTabNodeRelationships'
import Bridge8Button from './Bridge8Button'
import {errorCatch} from '../utils'
import AdminTabCart from './AdminTabCart'
import AdminTabSearch from './AdminTabSearch'

export default {
  name: 'AdminTab',
  data () {
    return {
      labels: [],
      label: null,
      nodes: [],
      node: null,
      nodeProperties: [],
      isEditMode: false
    }
  },
  props: {
    tabIndex: {
      type: Number,
      validator: num => {
        return Number.isInteger(num) && num >= 0
      }
    }
  },
  computed: {
    ...mapGetters('user', ['isAdmin', 'isManager'])
  },
  methods: {
    ...mapActions([
      'apiGetLabels',
      'apiGetNodes',
      'apiNodeGetProperties',
      'apiNodeCreate',
      'apiNodeClone',
      'apiNodeDelete',
      'apiNodeSetProperties',
      'apiUpdateNodesProperties'
    ]),
    refresh () {
      this.label = null
      this.node = null
      this.nodes = []
      this.labels = []
      return this.getLabels()
    },
    getLabels () {
      return this.apiGetLabels().then(labels => { this.labels = labels })
        .catch(errorCatch('Get Labels Failed.', this))
    },
    getNodes () {
      return this.apiGetNodes(this.label).then(nodes => {
        this.nodes = nodes
        return this.nodes
      })
        .catch(errorCatch('Get Nodes Failed.', this))
    },
    getNodeProperties () {
      return this.apiNodeGetProperties(this.node.uuid).then(props => { this.nodeProperties = props })
        .catch(errorCatch('Get Node Properties Failed.', this))
    },
    createNode () {
      return this.apiNodeCreate(this.label)
        .then(uuid => {
          this.getNodes().then(() => this.$bus.$emit('list-select-node', uuid))
        })
        .catch(errorCatch('Create Node Failed.', this))
    },
    cloneNode () {
      return this.apiNodeClone(this.node.uuid)
        .then(uuid => {
          this.getNodes().then(() => this.$bus.$emit('list-select-node', uuid))
        })
        .catch(errorCatch('Create Node Failed.', this))
    },
    deleteNode () {
      return this.apiNodeDelete(this.node.uuid).then(() => { this.getNodes() })
        .catch(errorCatch('Delete Node Failed.', this))
    },
    propertiesChanged (props) {
      const propsData = {}
      props.forEach(prop => {
        propsData[prop.key] = prop.value
      })
      // TODO: Check why it fires several times
      return this.apiNodeSetProperties({ uuid: this.node.uuid, props: propsData })
        .then(() => {
          this.getNodes()
          this.getNodeProperties()
        })
        .catch(errorCatch('Node Properties Change failed.', this))
    },
    tableUpdate () {
      this.$bus.$emit('admin-table-update-modal', data => {
        return this.apiUpdateNodesProperties(data)
          .then(() => {
            this.$notify.success({
              title: 'Update successful.',
              message: '',
              position: 'top right',
              timeOut: 5000,
              closeButton: true
            })
          })
          .catch(errorCatch('Nodes Properties Update failed.', this))
      })
    },
    addToCart () {
      this.$bus.$emit('admin-cart-add-node', this.node)
    },
    notImplemented () {
      this.$notify.warn({
        title: 'Not implemented yet.',
        message: null,
        position: 'top right',
        timeOut: 10000,
        closeButton: true
      })
    }
  },
  mounted () {
    this.getLabels()
    this.$bus.$on('admin-goto', ({label, node}) => {
      if (label === null) {
        this.label = label
        this.node = null
        this.nodes = []
        return
      }
      if (label !== this.label) {
        this.label = label
        this.nodes = []
        this.getNodes().then(() => {
          if (node) {
            this.$bus.$emit('admin-goto-node', node)
          }
        })
      } else if (node) {
        this.$bus.$emit('admin-goto-node', node)
      }
    })
    this.$bus.$on('admin-goto-node', node => {
      this.node = node
    })
  },
  beforeDestroy () {
    this.$bus.$off('admin-goto')
    this.$bus.$off('admin-goto-node')
  },
  watch: {
    node (newVal, oldVal) {
      if (newVal === null) {
        this.nodeProperties = []
        return
      }
      if (newVal !== oldVal) {
        this.getNodeProperties()
      }
    }
  },
  components: {
    AdminTabEntityProperties,
    AdminTabNodeRelationships,
    Bridge8SelectList,
    AdminTabCart,
    AdminTabSearch,
    Bridge8Button,
    mdbIcon,
    mdbBtn,
    mdbBtnGroup
  }
}
</script>

<style lang="sass" scoped>
.admin-tab-node-properties
  height: 30vh
  overflow: hidden

.selects-wrapper
  width: 25%
  height: 85vh

.btn
  .fas.fa-sm
    font-size: 1rem
    margin-top: -5px
</style>



// WEBPACK FOOTER //
// src/components/AdminTab.vue